import React, { useEffect, useState } from "react";
import './Faq.css'
import './Faq-responsive.css';
import { Ripple } from "primereact/ripple";
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Slide, Fade, JackInTheBox } from "react-awesome-reveal";
import { goToTop } from "../../../WebApp/Components/goToTop";
import NeedHelp from "../CommonSections/NeedHelp";
import { FaQCategory, faCategories, FaQuestion, faQuestions } from "./FaqData";
import { Accordion, AccordionTab } from "primereact/accordion";

const Faq: React.FC = () => {
    const [faqCategoryData, setFaqCategoryData] = useState<FaQCategory[]>([]);
    const [faqData, setFaqData] = useState<FaQuestion[]>([]);
    const [filteredFaqData, setFilteredFaqData] = useState<FaQuestion[]>([]);
    const [faqCategory, setFaqCategory] = useState<FaQCategory | null>(null);
    const [searchQuestion, setSearchQuestion] = useState<string>('');
    const [visibleFaqCount, setVisibleFaqCount] = useState<number>(10);
    const [showMoreText, setShowMoreText] = useState<string>('Show more');

    useEffect(() => {
        setFaqData(faQuestions);
        setFilteredFaqData(faQuestions);
        setFaqCategoryData(faCategories);
    }, []);

    useEffect(() => {
        applyFilters();
    }, [searchQuestion, faqCategory, faqData]);

    const handleFaqCategoryChange = (e: DropdownChangeEvent) => {
        const selectedCategory = e.value as FaQCategory;
        setFaqCategory(selectedCategory);
    }

    const applyFilters = () => {
        let filteredData = faqData;

        if (searchQuestion) {
            filteredData = filteredData.filter(faq =>
                faq?.question.toLowerCase().includes(searchQuestion.toLowerCase())
            );
        }

        if (faqCategory) {
            if (faqCategory?.category === "All") {
                filteredData = filteredData;
            } else {
                filteredData = filteredData.filter(faq =>
                    faq?.categoryId === faqCategory?.id
                );
            }
        }

        setFilteredFaqData(filteredData);
        setVisibleFaqCount(10);
        setShowMoreText('Show more');
    }

    const handleShowMore = () => {
        if (visibleFaqCount >= filteredFaqData.length) {
            setVisibleFaqCount(10);
            setShowMoreText('Show more');
            goToTop();
        } else {
            setVisibleFaqCount(prevCount => Math.min(prevCount + 10, filteredFaqData.length));

            if (visibleFaqCount + 10 >= filteredFaqData.length) {
                setShowMoreText('Show less');
            }
        }
    }

    return (
        <React.Fragment>
            {/* Faq section */}
            <section className="page_initial_section faq_init_section pattern_bg overflow-hidden">
                <div className="container-md">
                    <div className="page_heading_area">
                        <Slide direction="up" triggerOnce>
                            <h2 className="page_heading text-center">
                                Frequently Asked Questions
                            </h2>
                        </Slide>
                    </div>

                    <Slide direction="up" triggerOnce>
                        <div className="faq_data_filter_area">
                            <div className="faq_data_filter_input_container">
                                <IconField iconPosition="right">
                                    {searchQuestion === '' ? (
                                        <InputIcon className="bi bi-search"></InputIcon>
                                    ) : (
                                        <InputIcon className="bi bi-x-lg input_clear" onClick={() => setSearchQuestion('')}>
                                            <Ripple />
                                        </InputIcon>
                                    )}
                                    <InputText
                                        value={searchQuestion}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchQuestion(e.target.value)}
                                        placeholder="Search question"
                                        className="faq_filter_input"
                                        type="search"
                                    />
                                </IconField>
                            </div>

                            <div className="faq_data_filter_input_container">
                                <Dropdown
                                    id="faqCategory"
                                    value={faqCategory}
                                    onChange={handleFaqCategoryChange}
                                    options={faqCategoryData}
                                    optionLabel="category"
                                    panelClassName="category_option_panel"
                                    placeholder="Select category"
                                    className="form_dropdown faq_filter_category"
                                    filter
                                    filterPlaceholder="Search by category name"
                                    filterInputAutoFocus
                                    showClear
                                    emptyFilterMessage="No category found."
                                    emptyMessage="No category found."
                                    filterClearIcon
                                />
                            </div>
                        </div>
                    </Slide>

                    <div className="row faq_content">
                        <div className="col-12 col-xl-9 mx-auto">
                            {faqData && faqData?.length > 0 ? (
                                <React.Fragment>
                                    {filteredFaqData && filteredFaqData?.length > 0 ? (
                                        <React.Fragment>
                                            <Slide direction="up" triggerOnce >
                                                <Accordion activeIndex={0} className="faq_accordion_container">
                                                    {filteredFaqData.slice(0, visibleFaqCount).map((faq) => (
                                                        <AccordionTab key={faq?.id} className="faq_container"
                                                            contentClassName="faq_accordion_animation"
                                                            header={
                                                                <span className="faq_container_header">
                                                                    <h6>{faq?.question}</h6>
                                                                </span>
                                                            }>
                                                            <p className="faq_answer">
                                                                {faq?.answer}
                                                            </p>
                                                        </AccordionTab>
                                                    ))}
                                                </Accordion>
                                            </Slide>

                                            {filteredFaqData?.length > 10 && (
                                                <Slide direction="up" triggerOnce>
                                                    <div className="get_start_btn_area pt-4">
                                                        <button type="button" className="tdo_button btn_fill p-ripple" onClick={handleShowMore}>
                                                            {showMoreText}
                                                            <Ripple />
                                                        </button>
                                                    </div>
                                                </Slide>
                                            )}
                                        </React.Fragment>
                                    ) : (
                                        <Fade triggerOnce>
                                            <div className="no_data_found_container">
                                                <JackInTheBox triggerOnce>
                                                    <img src="/assets/images/website/common/no_question.svg" loading="lazy" alt="No questions found!" />
                                                </JackInTheBox>
                                                <Fade triggerOnce>
                                                    <h6>The question you searched for was not found!</h6>
                                                </Fade>
                                            </div>
                                        </Fade>
                                    )}
                                </React.Fragment>
                            ) : (
                                <Fade triggerOnce>
                                    <div className="no_data_found_container">
                                        <JackInTheBox triggerOnce>
                                            <img src="/assets/images/website/common/no_data.svg" loading="lazy" alt="No data found!" />
                                        </JackInTheBox>
                                        <Fade triggerOnce>
                                            <h6>No data found!</h6>
                                        </Fade>
                                    </div>
                                </Fade>
                            )}
                        </div>
                    </div>
                </div>
            </section>

            {/* Need help section */}
            <NeedHelp />
        </React.Fragment>
    )
}

export default Faq;